module.exports = __webpack_public_path__ + "assets/img/homepage_body_bg_green.webp?f305c127582c7045796c6da3b3c4d50c";